import React, { useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { HeroHeaderUrlBased } from '../../components/2.0version/heroHeaderUrlBased/HeroHeaderUrlBased';
import { IconButton } from '../../components/2.0version/iconButton/IconButton';
import { isLiked } from '../../components/2.0version/listingOt/cardOt/CardOt';
import RedHeartFull from '../../../static/redHeartFull.svg';
import RedHeart from '../../../static/redHeart.svg';
import ShareSvg from '../../../static/share.svg';
import { RoundCorners } from '../../components/2.0version/roundCorners/RoundCorners';
import { Breadcrumb } from '../../components/2.0version/breadcrumb/Breadcrumb';
import { useWishlistContext } from '../../hooks/contexts/useWishlistContext';
import { OtHeaderQuery, OtTemplateQuery } from '../../../graphql-types';
import * as styles from './otHeader.module.scss';
import { Modal } from '../../components/2.0version/modal/Modal';
import { Share } from '../../components/2.0version/share/Share';
import { usePageContext } from '../../hooks/contexts/usePageContext';

interface IOtLayoutProps {
  ot?: OtTemplateQuery['ingenieOt'];
}

export const getLinkIngenieReservable = (ot: OtTemplateQuery['ingenieOt'], lang: string) => {
  if (ot?.reservableLinkIngenie?.length === 0) return null;
  if (ot?.reservableLinkIngenie?.length === 1) return ot?.reservableLinkIngenie[0]?.url;
  const linkResa = ot?.reservableLinkIngenie?.filter((link) => link?.langue === lang);
  return linkResa?.length ? linkResa?.[0]?.url : ot?.reservableLinkIngenie?.[0]?.url;
};

export const OtHeader = ({ ot }: IOtLayoutProps) => {
  const { wishlist, modifyWishlist } = useWishlistContext();
  const { lang } = usePageContext();

  const { sanityTranslations } = useStaticQuery<OtHeaderQuery>(QUERY);

  const [open, setOpen] = useState(false);

  const liked = !!wishlist.find((x) => x.id === ot?.id);

  const linkResaIngenie = getLinkIngenieReservable(ot, lang);

  // TODO ask for VIDEOS
  let carouselItems: any = ot?.liens
    ?.filter((lien) => lien?.type === 'VIDEO')
    .map((lien) => ({
      _key: lien?.id,
      url: lien?.url,
      type: 'Video',
    }));

  if (carouselItems?.length === 0) {
    carouselItems = ot?.medias?.map((media) => {
      const alt = media?.attributs?.find((attr) => attr?.type === 'ALT');
      return {
        _key: media?.id,
        url: media?.url,
        alt,
        type: media?.type,
      };
    });
  }

  return (
    <>
      <HeroHeaderUrlBased urlBased={carouselItems[0]}>
        <div className={styles.headerContent}>
          <section>
            <h1 className={styles.title}>{ot?.libelle?.[lang] ?? ot?.libelle?.fr}</h1>
            <div className={styles.actionsWrapper}>
              <div>
                <IconButton
                  name="like"
                  type="button"
                  onClick={(e) => isLiked(e, ot, modifyWishlist)}
                >
                  <div className={styles.iconWrapper}>
                    {liked ? <RedHeartFull /> : <RedHeart />}
                  </div>
                </IconButton>
                <IconButton name="share" type="button" onClick={() => setOpen(!open)}>
                  <div className={styles.iconWrapper}>
                    <ShareSvg />
                  </div>
                </IconButton>
                {ot?.onlyReservableOnIngenie && linkResaIngenie && (
                  <a className={styles.resaButton} href={linkResaIngenie}>
                    {sanityTranslations?._rawLinkLabel?.[lang]}
                  </a>
                )}
              </div>
              <div>
                {ot?.pictosPartners?.map((picto, index) => (
                  <img
                    width={75}
                    height={75}
                    key={picto?.url ?? index}
                    src={picto?.url ?? ''}
                    alt={picto?.alt ?? 'logo placeholder'}
                    loading="lazy"
                  />
                ))}
              </div>
            </div>
          </section>
        </div>
      </HeroHeaderUrlBased>
      <RoundCorners>
        <Breadcrumb />
      </RoundCorners>
      <Modal fullScreenMobile setOpenModal={setOpen} open={open} translations={sanityTranslations}>
        <Share />
      </Modal>
    </>
  );
};

const QUERY = graphql`
  query OtHeader {
    sanityTranslations {
      _rawModalFilterReturn
      _rawLinkLabel
    }
  }
`;
